import Card from "./Card";

export type { ICardProps } from "./Card";

export default Card;
